/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
  const mainMenu = document.querySelector(".menu-wrapper");
  const body = document.querySelector("body");
  const button = document.querySelector("#menu-toggle");

  var mobileNavWrapper = document.querySelector("#mobile-nav-wrapper");
  var navWChildren = document.querySelectorAll(
    "#mobile-menu-inner > .menu-item-has-children > a"
  );
  var navWChildrenWChildren = document.querySelectorAll(
    "#mobile-menu-inner .menu-item-has-children > ul > div > .menu-item-has-children > a"
  );
  var subBacks = document.querySelectorAll(".sub-back");
  var subOpen = false;

  // // Return early if the button don't exist.
  if (!button) {
    return;
  }

  // Toggle the .menu-open class and the aria-expanded value each time the button is clicked.
  button.addEventListener("click", function () {
    if (body.classList.contains("menu-open")) {
      // console.log('close-menu');

      document.querySelector("html").classList.remove("menu-no-scroll");
      button.setAttribute("aria-expanded", "false");
      body.classList.remove("animate-menu");

      setTimeout(function () {
        mobileNavWrapper.classList.remove("sub-sub-open");
        mobileNavWrapper.classList.remove("sub-open");
        navWChildren.forEach((i) => {
          i.parentElement.classList.remove("sub-active");
        });
        navWChildrenWChildren.forEach((i) => {
          i.parentElement.classList.remove("sub-active");
        });
        body.classList.remove("menu-open");
      }, 300);
    } else {
      body.classList.add("menu-open");
      document.querySelector("html").classList.add("menu-no-scroll");
      button.setAttribute("aria-expanded", "true");
      mainMenu.classList.remove("hidden");
      setTimeout(function () {
        body.classList.add("animate-menu");
      }, 3);
    }
  });

  navWChildren.forEach((i) => {
    i.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the i from following its href
      // console.log("sub-open");
      if (!this.parentElement.classList.contains("sub-active")) {
        // Check if the i doesn't have the new class
        this.parentElement.classList.add("sub-active"); // Add the new class to the i
        mobileNavWrapper.classList.add("sub-open");
        var subOpen = false;
      }
    });
  });
  navWChildrenWChildren.forEach((i) => {
    i.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the i from following its href
      // console.log("sub-sub-open");
      if (!this.parentElement.classList.contains("sub-active")) {
        // Check if the i doesn't have the new class
        this.parentElement.classList.add("sub-active"); // Add the new class to the i
        mobileNavWrapper.classList.remove("sub-open");
        mobileNavWrapper.classList.add("sub-sub-open");
      }
    });
  });

  subBacks.forEach((i) => {
    i.addEventListener("click", (e) => {
      if (mobileNavWrapper.classList.contains("sub-open")) {
        mobileNavWrapper.classList.remove("sub-open");
      } else {
        mobileNavWrapper.classList.remove("sub-sub-open");
        mobileNavWrapper.classList.add("sub-open");
      }

      setTimeout(function () {
        i.parentElement.parentElement.parentElement.classList.remove(
          "sub-active"
        );
      }, 500);
    });
  });

  // var navHasChildren = document.querySelectorAll(".mobile-menu .menu-item-has-children");
  // navHasChildren.forEach((i) => {
  //   i.addEventListener("click", (e) => {
  //     if (!i.classList.contains("focused")) {
  //       i.classList.add("focused");

  //     } else {
  //       i.classList.remove("focused");
  //     }
  //   });
  // });

  // ctaButtons.forEach((i) => {
  //   i.addEventListener("click", (e) => {
  //     if (body.classList.contains("menu-open")) {
  //       document.querySelector("html").classList.remove("menu-no-scroll");
  //       button.setAttribute("aria-expanded", "false");
  //       body.classList.remove("menu-open");
  //       setTimeout(function() {
  //         mainMenu.classList.remove("animate-menu");
  //       }, 200);
  //     };
  //   });

  // });

  // // Remove the .menu-open class and set aria-expanded to false when the user clicks outside the navigation.
  // // Get all the link elements within the menu.
  // const links = menu.getElementsByTagName("a");
  // // Get all the link elements with children within the menu.
  // const linksWithChildren = menu.querySelectorAll(
  //   ".menu-item-has-children > a, .page_item_has_children > a"
  // );
  // // Toggle focus each time a menu link is focused or blurblue.
  // for (const link of links) {
  //   link.addEventListener("focus", toggleFocus, true);
  //   link.addEventListener("blur", toggleFocus, true);
  // }
  // // Toggle focus each time a menu link with children receive a touch event.
  // for (const link of linksWithChildren) {
  //   link.addEventListener("touchstart", toggleFocus, false);
  // }
  // /**
  //  * Sets or removes .focus class on an element.
  //  */
  // function toggleFocus() {
  //   if (event.type === "focus" || event.type === "blur") {
  //     let self = this;
  //     // Move up through the ancestors of the current link until we hit .nav-menu.
  //     while (!self.classList.contains("nav-menu")) {
  //       // On li elements toggle the class .focus.
  //       if ("li" === self.tagName.toLowerCase()) {
  //         self.classList.toggle("focus");
  //       }
  //       self = self.parentNode;
  //     }
  //   }
  //   if (event.type === "touchstart") {
  //     const menuItem = this.parentNode;
  //     event.preventDefault();
  //     for (const link of menuItem.parentNode.children) {
  //       if (menuItem !== link) {
  //         link.classList.remove("focus");
  //       }
  //     }
  //     menuItem.classList.toggle("focus");
  //   }
  // }
})();
